"use strict";Object.defineProperty(exports, "__esModule", {value: true});

var _QTH7UFAPcjs = require('../__chunks/QTH7UFAP.cjs');
require('../__chunks/XUEEOXY3.cjs');
require('../__chunks/MKJKL65R.cjs');
require('../__chunks/PFM4PJSG.cjs');
require('../__chunks/SARAALGA.cjs');




var _PTOCUU2Dcjs = require('../__chunks/PTOCUU2D.cjs');
require('../__chunks/3BSDKDKD.cjs');
require('../__chunks/XMDZRF6Y.cjs');

// src/menu/menu-description.tsx
var TagName = "p";
var useMenuDescription = _PTOCUU2Dcjs.createHook.call(void 0, 
  function useMenuDescription2(props) {
    props = _QTH7UFAPcjs.useHovercardDescription.call(void 0, props);
    return props;
  }
);
var MenuDescription = _PTOCUU2Dcjs.forwardRef.call(void 0, function MenuDescription2(props) {
  const htmlProps = useMenuDescription(props);
  return _PTOCUU2Dcjs.createElement.call(void 0, TagName, htmlProps);
});



exports.MenuDescription = MenuDescription; exports.useMenuDescription = useMenuDescription;
